/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useCallback } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { PageOverlay } from '../../components/PageOverlay/PageOverlay';
import { RootState } from '../../store';
import { closeCreateOrganizationOverlay } from '../../store/createOrganization/actions';
import { reactToCreateOrganization } from '../../utils/reactions';
import { CreateOrganizationOverlayForm } from './CreateOrganizationOverlay.Form';

const mapState = (state: RootState) => ({
  createOrganization: state.createOrganization,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;

const CreateOrganizationOverlayComponent = memo<PropsFromRedux>(props => {
  const { createOrganization, dispatch } = props;
  const { isOpen } = createOrganization;

  const close = useCallback(() => {
    dispatch(closeCreateOrganizationOverlay());
  }, [dispatch]);

  const onCreateOrganization = useCallback(() => {
    close();
    void reactToCreateOrganization();
  }, [close]);

  return (
    <PageOverlay
      open={isOpen}
      classes={{ childrenBlock: 'd-flex' }}
      showCloseBtn
      onCloseBtnClick={close}
      disableRestoreFocus
      name="create-organization"
    >
      {isOpen ? <CreateOrganizationOverlayForm onCreateOrganization={onCreateOrganization} /> : null}
    </PageOverlay>
  );
});

export const CreateOrganizationOverlay = connector(CreateOrganizationOverlayComponent);
